import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
  ],
  imports: [
    NgxDatatableModule
  ],
  exports: [
    NgxDatatableModule
  ]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts